import {createWebHistory, createRouter} from 'vue-router';
import {routes} from './routes';

const defaultTitle = 'Saving you money on tax | SalarySeed';
const defaultDescription = 'We help businesses save money by improving their salary sacrifice schemes';

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
        top: -30
      }
    }

    if (savedPosition) return savedPosition;
    
    return {top: 0}
  }
});

router.afterEach((to, from) => {
  if (to.meta) {
    const title = to.meta.title ? `${to.meta.title} | SalarySeed` : defaultTitle;
    const description = to.meta.description ? to.meta.description : defaultDescription;

    document.title = title;
    document.querySelectorAll('.document-title').forEach(el => el.setAttribute('content', title));
    document.querySelectorAll('.document-description').forEach(el => el.setAttribute('content', description));
  }
});

export default router;
